import { CommonAddinModule } from '@addins/common.module';
import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, Injector, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { Addin, AddinModule } from '@techwan/ionic-core';

import { HttpClientModule } from '@angular/common/http';
import { DocumentsProxyService } from './services/documents-proxy/documents-proxy.service';
import { DocumentsService } from './services/documents/documents.service';
import { DocumentsMenuService } from './services/executables/documents-menu/documents-menu.service';
import { DocumentsViewComponent } from './views/documents-view/documents-view.component';

const directives = [];

const views = [DocumentsViewComponent];

const components = [...views];

const executables = [DocumentsMenuService];

const providers = [DocumentsProxyService, DocumentsService, ...executables];

@NgModule({
  declarations: [...components, ...directives],
  imports: [CommonModule, FormsModule, HttpClientModule, IonicModule, CommonAddinModule],
  exports: components,
  providers,
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
@Addin({
  name: 'Documents'
})
export class DocumentsModule extends AddinModule {
  constructor(injector: Injector) {
    super(injector, views, executables);
  }
}
